import { makeAutoObservable } from 'mobx';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { OpenapiProxyStaffAccountAffordabilityResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_account_affordability';
import { getDepositLimits } from 'src_server/types/responsibleGambling';
import { Amount } from 'src_common/common/amount/Amount';

type BadgeType = 'colorBadge' | 'depositBadge' | 'depositBadgeDefault';

export class CustomerSummaryTabAffordabilityState {
    public constructor(
        private readonly affordabilityStatusResource: Resource<OpenapiProxyStaffAccountAffordabilityResponse200Type>,
        private readonly depositLimitsResource: Resource<getDepositLimits.ResponseType> | null
    ) {
        makeAutoObservable(this);
    }

    public get affordabilityStatus(): OpenapiProxyStaffAccountAffordabilityResponse200Type | null {
        return this.affordabilityStatusResource.getReady();
    }

    public get rollingDepositLimitsUsed(): getDepositLimits.ResponseType | null {
        return this.depositLimitsResource?.getReady() ?? null;
    }

    public get rollingDepositLimits(): null | string {
        if (this.rollingDepositLimitsUsed?.responseStatus === 'success') {
            const usedValue = this.rollingDepositLimitsUsed.data.limits.find((item) => {
                return item.windowLengthInDays === 30;
            })?.used;

            return usedValue === undefined ? '0' : new Amount(usedValue.toString()).div(100).format('GBP');
        }
        return '0';
    }

    public get resultBadge(): BadgeType {
        const affordabilityStatus = this.affordabilityStatusResource.getReady();

        if (affordabilityStatus === null) {
            return 'depositBadgeDefault';
        }

        const affordabilityColor = affordabilityStatus.affordabilityColor?.toLowerCase();
        if (affordabilityColor === 'red' || affordabilityColor === 'amber' || affordabilityColor === 'green') {
            return 'colorBadge';
        }

        const depositSum = affordabilityStatus.depositSum ?? null;
        const lastCheckDate = affordabilityStatus.lastCheckDate ?? null;

        if (depositSum !== null && lastCheckDate === null) {
            return 'depositBadge';
        }

        return 'depositBadgeDefault';
    }
}
